import { render } from "./EditInstructor.vue?vue&type=template&id=00eab144&scoped=true"
import script from "./EditInstructor.vue?vue&type=script&lang=js"
export * from "./EditInstructor.vue?vue&type=script&lang=js"

import "./EditInstructor.vue?vue&type=style&index=0&id=00eab144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eab144"]])

export default __exports__